import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import NumberFormat from './NumberFormat';
import { Icon, Popover } from 'antd';
import moment from 'moment';

class TagsDiscount extends Component {
  constructor(props) {
    super(props);
  }
  getVolumePrice(rank_discounts, base_price_per_day, currency) {
    const { t } = this.props;
    let priceVolumeList = [];
    rank_discounts.forEach((rank_discount, key) => {
      priceVolumeList.push(
        <div key={key}>
          <Icon type="tags" theme="outlined"></Icon>
          {t(rank_discount.range)} {rank_discount.discount} % dto.
          <p className="textDiscount">
            <NumberFormat
              tax={false}
              value={base_price_per_day - (base_price_per_day * rank_discount.discount) / 100}
              currency={currency}
            />
            /{t('Day')}
          </p>
        </div>
      );
    });
    return priceVolumeList;
  }
  getNextVolumeDiscount(displays, dateFrom, dateTo) {
    let diffDay = moment(dateTo).diff(dateFrom, 'days') + 1;
    let nextDiscount;
    let listDiscount = displays.rank_discounts;
    if (listDiscount === undefined || (listDiscount && listDiscount.length == 0)) return null;

    listDiscount.forEach(function(discount) {
      if (diffDay < discount.min_range && !nextDiscount)
        nextDiscount = discount.min_range - diffDay;
    });

    if (!nextDiscount) return null;

    return nextDiscount;
  }

  render() {
    const {
      t,
      display,
      currency,
      color,
      withText,
      backgroundColor = 'transparent',
      dateFrom,
      dateTo
    } = this.props;
    let nextDiscount;

    if (display.rank_discounts && display.rank_discounts.length > 0 && dateFrom && dateTo) {
      nextDiscount = this.getNextVolumeDiscount(display, dateFrom, dateTo);
    }

    const alertStyle = withText
      ? {
          color: color,
          backgroundColor: backgroundColor,
          padding: '8px 12px',
          borderRadius: '4px',
          display: 'inline-flex',
          alignItems: 'center'
        }
      : {
          color: color
        };

    return (
      <Popover
        content={this.getVolumePrice(
          display.rank_discounts,
          display.base_price_per_day ? display.base_price_per_day : display.price_per_day,
          currency
        )}
        title={t('Volume discount')}
      >
        <span className="primary" style={alertStyle}>
          <Icon type="tags" theme="outlined"></Icon>
          {withText && (
            <span style={{ marginLeft: '10px' }}>
              {nextDiscount
                ? t('Increase n_diff_discount your campaign to access higher discounts').replace(
                    'n_diff_discount',
                    nextDiscount + ' ' + (nextDiscount > 1 ? t('days') : t('day'))
                  )
                : t('You already have all discounts applied!')}
            </span>
          )}
        </span>
      </Popover>
    );
  }
}

export default withTranslation()(TagsDiscount);
